import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from '../../translation'

import { msecToTime } from 'utils/conversion'

const PlayerPlaylistNextSong = ({
  currentSongRemainingSec,
  allSongsMap,
  playlist,
  playingPlaylistSong,
}) => {
  const currentSongIndex = playingPlaylistSong
  const numberOfSongsLeft = playlist.slice(playingPlaylistSong + 1).length

  if (numberOfSongsLeft) {
    const msecsPerSong = 20 * 60 * 1000
    const timeLeft = msecToTime(
      msecsPerSong * numberOfSongsLeft + currentSongRemainingSec * 1000,
      'm'
    )
    const nextSongId = playlist[currentSongIndex + 1]
    const nextSongInfo = allSongsMap[nextSongId]

    return (
      <div className="player_duration_timeline_wrap">
        <div className="player_duration_timeline_list">
          <span className="playlist_next_label">
            {t('playlist.NEXT_SONG')}:&nbsp;
            <span className="playlist_next_time">
              <strong>{nextSongInfo.title}</strong> {t('player.BY')}{' '}
              <span className="playlist_next_artist">{nextSongInfo.artist}</span>
            </span>
          </span>
        </div>
        <div className="player_duration_timeline_list">
          <div className="player_duration_timeline_label center_mod">
            {t('playlist.APPROXIMATELY_TIME_LEFT', {
              timeLeft,
            })}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="player_duration_timeline_wrap">
        <div className="player_duration_timeline_list">
          <div className="player_duration_timeline_label center_mod">
            {t('playlist.PLAYING_LAST_PLAYLIST_SONG')}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ player: { allSongsMap, playlist, playingPlaylistSong } }) => ({
  allSongsMap,
  playlist,
  playingPlaylistSong,
})

export default connect(mapStateToProps)(PlayerPlaylistNextSong)

PlayerPlaylistNextSong.propTypes = {
  allSongsMap: PropTypes.object.isRequired,
  currentSongRemainingSec: PropTypes.number.isRequired,
  playlist: PropTypes.array.isRequired,
  playingPlaylistSong: PropTypes.number.isRequired,
}
